module.exports = __webpack_public_path__ + "static/Eyeglasss3_3-2d9e7d8b5ced4f96e0a69a9607bd9ed6.png";